







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Alert extends Vue {
	private alert = false;
	private title = '';
	private message = '';
	private type = '';

	created() {
		const component = this;
		this.$nuxt.$on('warning', function(params) {
			component.type = 'warning';
			component.title = params.title ? params.title : '';
			component.message = params.message;
			component.alert = true;
		});
		this.$nuxt.$on('error', function(params) {
			component.type = 'error';
			component.title = params.title ? params.title : '';
			component.message = params.message;
			component.alert = true;
		});
		this.$nuxt.$on('success', function(params) {
			component.type = 'success';
			component.title = params.title ? params.title : '';
			component.message = params.message;
			component.alert = true;
		});
	}
}
